import { HttpClient } from '@angular/common/http';
import { AppConfig } from 'src/app/app.config';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../app.config";
var PricelistService = /** @class */ (function () {
    function PricelistService(http, config) {
        this.http = http;
        this.config = config;
    }
    PricelistService.prototype.get = function (id) {
        return this.http.get(this.config.getConfig("apiEndpoint") + "/pricelists" + (id ? "/" + id : ""));
    };
    PricelistService.prototype.datatable = function (f) {
        return this.http.post(this.config.getConfig("apiEndpoint") + "/pricelists/dt", f);
    };
    PricelistService.prototype.delete = function (id) {
        return this.http.delete(this.config.getConfig("apiEndpoint") + "/pricelists/" + id);
    };
    PricelistService.prototype.upsert = function (v) {
        return this.http.post(this.config.getConfig("apiEndpoint") + "/pricelists", v);
    };
    PricelistService.ngInjectableDef = i0.defineInjectable({ factory: function PricelistService_Factory() { return new PricelistService(i0.inject(i1.HttpClient), i0.inject(i2.AppConfig)); }, token: PricelistService, providedIn: "root" });
    return PricelistService;
}());
export { PricelistService };
